var exports = {
  "kL": "Toasts.module__container___UE1vN0",
  "Kd": "Toasts.module__containerMobile___UE1vN0",
  "QX": "Toasts.module__containerDesktop___UE1vN0",
  "T_": "Toasts.module__toastWrapper___UE1vN0",
};

module.exports = exports;
